import { WandSparkles } from 'lucide-react-native';
import React from 'react';
import { View } from 'react-native';

/**
 * Same size as ⓘ (`ICON_INFO` = 16px). Figma sparkle-pencil is not in this
 * bundle — Lucide `WandSparkles` is the cross-platform stub (web + native).
 * Do not treat it as DoD; swap the child when UX delivers the asset.
 */
export const TEXT_ASSIST_PLACEHOLDER_SIZE = 16;

export type TextAssistPlaceholderIconProps = {
  size?: number;
  color: string;
};

/**
 * Wand glyph only — no tile. Same Lucide stroke on web and native.
 */
export function TextAssistPlaceholderIcon({
  size = TEXT_ASSIST_PLACEHOLDER_SIZE,
  color,
}: TextAssistPlaceholderIconProps): React.ReactElement {
  return (
    <View
      testID="text-assist-placeholder-icon"
      importantForAccessibility="no"
      style={{ width: size, height: size }}
    >
      <WandSparkles size={size} color={color} strokeWidth={2} />
    </View>
  );
}
